<script lang="ts">
    import { Col } from "sveltestrap";
    import { ActivityLog } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import data from "../../../Data/SocialApp/SocialApp.json"
    import FeatherIcon from "svelte-feather-icon";
</script>
<Col sm="12">
    <Card headerTitle={ActivityLog} cardBodyprops="pt-0">
      <div slot="contentbody">
        <div class="activity-log">
          {#each data.activitydata as likes}
            <div class="my-activity">
              <h6 class="f-w-600 mb-3">{likes.date}</h6>
              {#each likes.likesdata as likesItem}
                <p>
                  <span>
                    <FeatherIcon class="m-r-20" icon={likesItem.icon}/>
                  </span>{likesItem.line}
                </p>
              {/each}
            </div>
          {/each}
        </div>
      </div>
    </Card>
</Col>